import Project from './Project'
import User from './User'

export default {
  ...Project,
  ...User,
}